import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttonashikcab() {



const cardData = {
  keyword: " Mumbai Airport to Nashik Cab  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Nashik cab services, ensuring a smooth and hassle-free journey for business trips, family travel, and leisure trips. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai Airport to Nashik convenient and stress-free. The journey covers approximately 170–180 km via the Mumbai–Nashik Highway and typically takes about 3.5 to 4.5 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Nashik cab travel.",

topPlaces: [
  {
    title: "Sula Vineyards",
    description: "Sula Vineyards is a famous winery in Nashik known for its beautiful vineyards, wine tasting tours, and scenic views. Travelers from Mumbai Airport can enjoy guided tours of the winery, sample premium wines, and dine at the vineyard’s restaurants. The spacious cab ensures a comfortable and relaxed journey to this popular destination."
  },
  {
    title: "Trimbakeshwar Temple",
    description: "Trimbakeshwar Temple is one of the twelve Jyotirlinga shrines dedicated to Lord Shiva. Visitors traveling from Mumbai Airport can reach the temple conveniently by cab, experience the spiritual ambiance, and participate in rituals. It is a significant religious site attracting pilgrims from across India."
  },
  {
    title: "Pandav Leni Caves",
    description: "Pandav Leni Caves are ancient rock-cut caves located near Nashik, showcasing historical architecture and carvings. Travelers can take a cab from Mumbai Airport to explore these archaeological sites, enjoy the serene surroundings, and learn about the region’s history."
  },
  {
    title: "Anjneri Hill",
    description: "Anjneri Hill is a popular trekking spot near Nashik, believed to be the birthplace of Lord Hanuman. Visitors arriving by cab can enjoy scenic trekking trails, panoramic views, and natural beauty. The cab provides a comfortable ride to the base of the hill before the trek."
  },
  {
    title: "Kalaram Temple",
    description: "Kalaram Temple is an ancient temple in Nashik dedicated to Lord Rama, known for its black stone idols and historic architecture. Travelers from Mumbai Airport can reach this landmark easily by cab, experience its religious significance, and explore nearby markets."
  },
  {
    title: "Gangapur Dam",
    description: "Gangapur Dam is a serene spot in Nashik, ideal for picnics and nature photography. Travelers using a cab from Mumbai Airport can enjoy the peaceful surroundings, water views, and nearby eateries, making it a great stop for a short excursion."
  },
  {
    title: "Coin Museum",
    description: "The Coin Museum in Nashik showcases rare coins from ancient India and various civilizations. Visitors traveling by cab from Mumbai Airport can explore the exhibits, learn about historical currency, and enjoy an educational experience."
  },
  {
    title: "Ram Kund",
    description: "Ram Kund is a sacred bathing ghat on the Godavari River in Nashik. Travelers arriving from Mumbai Airport can experience religious rituals, enjoy the riverside view, and understand the cultural importance of this site. The cab ensures a convenient and comfortable journey to the ghats."
  },
  {
    title: "Saptashrungi Temple",
    description: "Saptashrungi Temple is a revered temple located atop a hill near Nashik, dedicated to Goddess Saptashrungi. Visitors can reach the base of the hill by cab from Mumbai Airport and then climb to the temple to enjoy panoramic views and a spiritual experience."
  },
  {
    title: "Gangapur Waterfalls",
    description: "Gangapur Waterfalls is a scenic destination near Nashik, perfect for nature lovers and photographers. Travelers from Mumbai Airport can take a cab for a comfortable ride, enjoy the waterfall views, and spend time relaxing in the natural surroundings."
  }
],



services: [
{
name: "Mumbai Airport to Nashik Cab Service",
description: "Mumbai Airport to Nashik cab service offers a seamless and comfortable journey for travelers arriving at the airport and heading towards Nashik for business, pilgrimage, or leisure. This service is ideal for passengers landing at Terminal 1 or Terminal 2 who require a direct and hassle-free transfer to Nashik. The route covers scenic highways, vineyards, and religious destinations, making the journey pleasant and relaxing. Professional drivers monitor flight timings to ensure timely pickup without delays, even in case of early arrivals or late-night landings. Customers can choose from a variety of vehicles including sedan, SUV, and premium cars depending on group size and comfort preference. Doorstep drop in Nashik including areas like Panchavati, Gangapur Road, and industrial zones ensures complete convenience. With transparent pricing, 24x7 availability, and easy booking, this service guarantees a smooth airport transfer experience."
},
{
name: "Mumbai Airport to Nashik Taxi",
description: "Mumbai Airport to Nashik taxi service provides reliable and comfortable transportation for long-distance travel with well-maintained vehicles and experienced drivers. This service is perfect for travelers who prefer a direct and private journey from the airport to Nashik. Spacious seating, clean interiors, and smooth ride quality ensure passenger comfort throughout the trip. Drivers are experienced in highway driving and ensure safe and timely arrival. Multiple vehicle options such as sedan and SUV cater to different travel needs. Flexible pickup from airport terminals makes it convenient. It ensures a stress-free and comfortable journey."
},
{
name: "One Way Cab Mumbai Airport to Nashik",
description: "One way cab Mumbai Airport to Nashik is a cost-effective travel option for passengers who need a single-side drop without paying for return charges. This service is ideal for business travelers, tourists, and pilgrims visiting Nashik. Customers benefit from competitive pricing, flexible pickup timing, and quick booking options. Professional drivers ensure safe and efficient travel across highways. Various vehicle options are available based on comfort and budget. Online booking with instant confirmation adds convenience. It is a practical and affordable travel solution."
},
{
name: "Mumbai Airport to Nashik Cab Booking",
description: "Mumbai Airport to Nashik cab booking allows customers to reserve their ride easily with instant confirmation and flexible scheduling. Travelers can choose vehicle type, pickup time, and drop location according to their needs. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide secure payment options and real-time availability. Dedicated customer support assists with any travel queries. This service ensures a smooth and organized travel experience. It is the most convenient way to plan airport transfers."
},
{
name: "Mumbai Airport to Nashik Taxi Fare",
description: "Mumbai Airport to Nashik taxi fare is designed to be transparent and budget-friendly, helping travelers plan their journey without confusion. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a clear cost breakdown including tolls, parking, and driver allowance where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. Flexible fare options allow customers to choose according to their budget. It offers great value for long-distance travel."
},
{
name: "Mumbai Airport to Nashik Outstation Cab",
description: "Mumbai Airport to Nashik outstation cab service provides reliable travel solutions for intercity journeys with comfort and safety. This service is ideal for tourists, families, and business travelers. Vehicles are well-maintained for long-distance highway travel ensuring smooth performance. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup directly from airport terminals adds convenience. It ensures a hassle-free and enjoyable travel experience."
},
{
name: "Cheap Cab Mumbai Airport to Nashik",
description: "Cheap cab Mumbai Airport to Nashik offers budget-friendly travel options without compromising on comfort and safety. This service is perfect for cost-conscious travelers looking for reliable transportation at affordable rates. Sedan vehicles provide economical pricing for long-distance travel. Transparent billing ensures no hidden charges. Professional drivers ensure smooth and safe journeys. Flexible booking options make it easy for customers to plan trips. It is an ideal choice for affordable travel."
},
{
name: "Mumbai Airport to Nashik SUV Taxi",
description: "Mumbai Airport to Nashik SUV taxi is ideal for families and groups who need extra space and comfort during travel. SUVs provide spacious seating and better road performance on highways. This option is suitable for long-distance journeys with luggage and multiple passengers. Professional drivers ensure safe and comfortable travel throughout the route. It offers a premium experience with enhanced comfort. Perfect for group travel. It ensures a smooth and enjoyable journey."
},
{
name: "Mumbai Airport to Nashik Sedan Cab",
description: "Mumbai Airport to Nashik sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable yet economical ride. Sedans provide smooth travel, good mileage, and comfortable seating for long-distance trips. This service is ideal for budget-friendly travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup from airport terminals adds ease. It is one of the most preferred options. It ensures a pleasant journey."
},
{
name: "Mumbai Airport to Nashik Car Rental",
description: "Mumbai Airport to Nashik car rental service provides flexible travel options with a wide range of vehicles to choose from. Customers can book cars for one way or round trip journeys based on their needs. This service is ideal for personal travel, corporate trips, and family vacations. Easy booking process and transparent pricing make it convenient for customers. Vehicles are clean, well-maintained, and driven by professional chauffeurs. Flexible pickup from airport ensures convenience. It ensures a customized and comfortable travel experience."
},
{
name: "Private Cab Mumbai Airport to Nashik",
description: "Private cab Mumbai Airport to Nashik offers a personalized travel experience with exclusive vehicle usage for passengers. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey from the airport to Nashik. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating and premium service enhance the experience. It is ideal for private and luxury travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai Airport to Nashik",
description: "AC taxi Mumbai Airport to Nashik ensures a comfortable journey in air-conditioned vehicles for long-distance travel. This service is ideal for passengers who prefer a cool and pleasant environment during travel. Clean interiors and well-maintained AC systems enhance comfort. Suitable for families, tourists, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing and smooth journey."
},
{
name: "Book Mumbai Airport to Nashik Cab Online",
description: "Book Mumbai Airport to Nashik cab online for quick and hassle-free reservations with instant confirmation. Customers can select vehicle type, pickup time, and drop location easily through online platforms. Secure payment options and transparent pricing ensure a smooth booking process. This service ensures vehicle availability even during peak hours. Dedicated support is available for assistance anytime. It simplifies travel planning for airport transfers. It is the most convenient booking option."
},
{
name: "Mumbai Airport to Nashik Round Trip Cab",
description: "Mumbai Airport to Nashik round trip cab service is ideal for travelers who require return travel after completing their trip. This package includes pickup, drop, waiting time, and return journey with flexible scheduling. Travelers can plan their visit without worrying about return transport. Professional drivers ensure safe and timely service throughout the trip. Multiple vehicle options are available for different group sizes. It offers convenience and cost efficiency. It ensures a complete travel solution."
}
],

tableData: [
["Mumbai Airport to Nashik Cab Service","Mumbai Airport to Nashik Taxi"],
["One Way Cab Mumbai Airport to Nashik","Mumbai Airport to Nashik Cab Booking"],
["Mumbai Airport to Nashik Taxi Fare","Mumbai Airport to Nashik Outstation Cab"],
["Cheap Cab Mumbai Airport to Nashik","Mumbai Airport to Nashik SUV Taxi"],
["Mumbai Airport to Nashik Sedan Cab","Mumbai Airport to Nashik Car Rental"],
["Private Cab Mumbai Airport to Nashik","AC Taxi Mumbai Airport to Nashik"],
["Book Mumbai Airport to Nashik Cab Online","Mumbai Airport to Nashik Round Trip Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Airport to Nashik Transfer",
    WhyChoosedescription: "Velocity Cabs offers dependable Mumbai Airport to Nashik cab service with timely pickups from Terminal 1 and Terminal 2, ensuring a smooth and stress-free journey."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai to Nashik highway routes, ensuring safe driving, proper route selection, and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai Airport to Nashik cab bookings. Customers receive complete fare details including toll charges and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport to Nashik cab service operates 24/7. Whether your flight lands early morning or late night, we ensure reliable cab availability."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel plans between Mumbai Airport and Nashik."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Nashik cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport to Nashik cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport to Nashik for one-way and round-trip travel." },
  { question: "How far is Nashik from Mumbai Airport?", answer: "The distance between Mumbai Airport and Nashik is approximately 165 to 180 km and travel time is around 3.5 to 4.5 hours." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai Airport to Nashik cab service operates 24/7." },
  { question: "Which terminals are covered?", answer: "We provide pickup from all terminals including Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport to Nashik cabs online or through phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Jadhav",
    feedback:
      "The Mumbai Airport to Nashik cab ride was very smooth and well-coordinated. The pickup was on time, and the long journey felt comfortable and stress-free throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Traveling from Mumbai Airport to Nashik was a pleasant experience. The cab was clean, the drive was steady, and the overall service felt reliable and professional.",
    rating: 5
  }
];























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiAirportNashikCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Airport to Nashik Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai Airport to Nashik for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai Airport to Nashik Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai Airport to Nashik",
        "description": "Private cab from Mumbai Airport to Nashik for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai Airport to Nashik Cab",
        "description": "Comfortable round-trip cab service from Mumbai Airport to Nashik with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Nashik Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai Airport to Nashik for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportNashikCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttonashikcab;